module.exports = __webpack_public_path__ + "components/flag/static/square/pw-70a4598cd954c1285e79effc71042ac2.svg";